import { createKeyedDataAsyncSlice } from '../../../../createKeyedDataAsyncSlice';
import {
  getBankAccountForCategoryAndState,
  getDestinationAccountsForState,
} from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSliceWithDataAndQuery } from '../../../../createAsyncSliceWithDataAndQuery';

export const { slice: getBankAccountForCategoryAndStateSlice, asyncAction: getBankAccountForCategoryAndStateAction } =
  createKeyedDataAsyncSlice(
    'getBankAccountForCategoryAndState',
    getBankAccountForCategoryAndState,
    (request) => request.rowIndex
  );

export const { slice: getDestinationAccountsForStateSlice, asyncAction: getDestinationAccountsForStateAction } =
  createAsyncSliceWithDataAndQuery('getDestinationAccountsForState', getDestinationAccountsForState, []);
